<template>
    <div class="menus">
        <router-link
            v-for="(item, i) in menus"
            :key="i"
            :to="item.path">
            {{ item.name }}
        </router-link>
    </div>
</template>
<script>
import Service from '@/service/index'

const STATS = {
    name: '广告主',
    path: '/stats'
}


const ALL = [
    STATS
]
let task = 0
export default {
    name: 'top_menu',
    data () {
        return {
            menus: [],
        }
    },
    watch: {
        roles (roles) {
            this.getMenus(roles)
        }
    },
    mounted () {
        this.getMenus(this.roles)
    },
    beforeDestroy () {
        task && clearInterval(task)
    },
    methods: {
        getMenus (roles) {
            const ROLE_MAP = {
                admin: 'all',
                staff: 'all',
                editor: 'editor',
                advertiser: 'advertiser',
                answerer: 'answerer'
            }
            const MENU_PERMIT = {
                all: ALL,
                editor: [],
                advertiser: [STATS],
                answerer: []
            }
            let menus = []
            roles.some((role) => {
                const permitKey = ROLE_MAP[role]
                const newMenu = MENU_PERMIT[permitKey]
                if (permitKey === 'all') {
                    menus = newMenu
                    return true
                }
                menus = menus.concat(newMenu)
            })
            this.menus = menus
        }
    },
    props: {
        roles: {
            type: Array,
            default () {
                return []
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.menus {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    a {
        height: 100%;
        padding: 0 24px;
        line-height: 60px;
        color: #fff;
        text-decoration: none;
        &.router-link-exact-active {
            background-color: rgba(0, 0, 0, .1);
        }
    }
}
</style>
